// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-92addb4c] .chips-container p.bold {\n  font-weight: 100 !important;\n  color: #6c757d !important;\n}", ""]);
// Exports
module.exports = exports;
